const CompletedWithDelayIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" fill="#FCFAEA" />
      <path
        d="M23 15.9999C23 19.691 20.1265 22.7165 16.5 22.9746V21.9746C19.575 21.7192 22 19.1396 22 15.9999C22 12.6916 19.3086 9.99995 16 9.99995C12.6914 9.99995 10 12.6916 10 15.9999C10 19.1191 12.3931 21.6876 15.4395 21.9715L14.797 22.8891C11.5095 22.3162 9 19.4489 9 16C9 12.1401 12.1402 9 16 9C19.8598 9 23 12.1401 23 15.9999ZM16.5 16.134V11.9999H15.5V15.8659L13.4017 19.5H14.5566L16.5 16.134Z"
        fill="#111113"
      />
    </svg>
  )
}

export default CompletedWithDelayIcon
